import {rpc} from './session';

export async function find(data) {
    return await rpc.request('com.rnis.routing.action.find', data);
}


// WEBPACK FOOTER //
// ./src/helpers/api/routing.js